import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackAddOfferClick } from './tracking';
import { AddOfferButton } from '../../components/AddOfferButton';
import { IApplicationState } from '../../types/redux';

export const AddOfferButtonContainer: React.FC = () => {
  const [isOfferFormPage, setIsOfferFormPage] = React.useState(false);
  const placeOfferLink = useSelector<IApplicationState, string | null>(state => state.servicesLinks.placeOffer);

  React.useEffect(() => {
    setIsOfferFormPage(window.location.pathname.includes('/razmestit-obyavlenie'));
  }, []);

  const handleClick = React.useCallback(() => {
    trackAddOfferClick();
    window.open(placeOfferLink as string);
  }, []);

  if (isOfferFormPage || !placeOfferLink) {
    return null;
  }

  return <AddOfferButton onClick={handleClick} />;
};
